/* Progressive enhancement: all navigation remains visible without JavaScript. */
(() => {
  const button = document.querySelector('.vovi-menu-toggle');
  const navigation = document.getElementById('vovi-main-navigation');
  if (!button || !navigation) return;
  const mobile = window.matchMedia('(max-width: 900px)');
  const close = () => {
    navigation.querySelectorAll('details[open]').forEach(item => { item.open = false; });
    if (mobile.matches) {
      navigation.hidden = true;
      button.setAttribute('aria-expanded', 'false');
    }
  };
  const sync = () => {
    button.hidden = !mobile.matches;
    if (mobile.matches && navigation.contains(document.activeElement)) button.focus();
    navigation.hidden = mobile.matches;
    button.setAttribute('aria-expanded', String(!mobile.matches));
  };
  button.addEventListener('click', () => {
    navigation.hidden = !navigation.hidden;
    button.setAttribute('aria-expanded', String(!navigation.hidden));
  });
  button.addEventListener('keydown', event => {
    if (event.key === 'Escape' && mobile.matches && !navigation.hidden) {
      event.preventDefault(); close(); button.focus();
    }
  });
  navigation.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const disclosure = event.target.closest('details[open]');
    if (disclosure) {
      disclosure.open = false;
      disclosure.querySelector('summary').focus();
    } else if (mobile.matches) {
      close();
      button.focus();
    }
  });
  mobile.addEventListener('change', sync);
  sync();
})();

// Refresh the server-rendered count after returning through the browser history.
(() => {
 const link=document.querySelector('[data-vovi-cart-link]'), badge=link?.querySelector('[data-vovi-cart-count]');
 if(!link||!badge)return;
 async function refresh(){
  try{
   const url=new URL(link.href);url.pathname=url.pathname.replace(/\/$/,'')+'.js';url.search='';
   const response=await fetch(url,{cache:'no-store'});if(!response.ok)return;
   const cart=await response.json(),count=cart.item_count;if(!Number.isInteger(count)||count<0)return;
   badge.textContent=String(count);badge.hidden=count===0;link.setAttribute('aria-label',`Warenkorb, ${count} Artikel`);
  }catch{/* Retain the last server-confirmed count. */}
 }
 window.addEventListener('pageshow',refresh);
 document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible')void refresh();});
 document.addEventListener('vovi:cart-updated',refresh);
})();
